export { Accordion } from '@mantine/core'
